import React from 'react';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { useRefundMethodsList } from '../context';
import * as RefundMethodToggle from '../../RefundMethodToggle';
import { REFUND_METHOD_HELP_TEXT_MAP } from '../stubs';

export default function RefundMethod({ data = {} }) {
  const {
    refundMethodNameMap,
    onSetAsDefault,
    isSettingDefault
  } = useRefundMethodsList();
  const { isActive, isProcessing } = RefundMethodToggle.useRefundMethodToggle();

  const paymentMethod = _get(data, 'payment_method', '');
  const isDefault = _get(data, 'is_default', false);
  const helpText = _get(REFUND_METHOD_HELP_TEXT_MAP, paymentMethod, '');
  const title = _get(refundMethodNameMap, paymentMethod, '');

  const handleSetAsDefault = () => {
    onSetAsDefault(data);
  };

  return (
    <UiKit.Card>
      <UiKit.Card.Body>
        <UiKit.Flex gap={16}>
          <UiKit.Flex className={styles.toggleContainer} align="center">
            <RefundMethodToggle.Switch />
          </UiKit.Flex>
          <UiKit.Flex direction="column" className="flex-grow-1">
            <UiKit.Flex gap={24} align="center" justify="space-between">
              <UiKit.Flex gap={16} align="center">
                <UiKit.Text weight="bold">{title}</UiKit.Text>
              </UiKit.Flex>
              <If
                test={isDefault}
                otherwise={
                  <UiKit.Tooltip disabled={isActive}>
                    <UiKit.Tooltip.Content>
                      Enable the refund method to set it as default
                    </UiKit.Tooltip.Content>
                    <UiKit.Tooltip.Trigger>
                      <UiKit.Button
                        size="sm"
                        variant="ghost"
                        onClick={handleSetAsDefault}
                        disabled={isProcessing || isSettingDefault || !isActive}
                      >
                        Set as Default
                      </UiKit.Button>
                    </UiKit.Tooltip.Trigger>
                  </UiKit.Tooltip>
                }
              >
                <UiKit.Tag>Default</UiKit.Tag>
              </If>
              {/* <RefundMethodConfig.Provider methodSlug={slug} onSaved={onReload}>
                <RefundMethodConfig.Trigger isDisabled={isProcessing}>
                  <PenIcon />
                  Edit
                </RefundMethodConfig.Trigger>
              </RefundMethodConfig.Provider> */}
            </UiKit.Flex>
            <UiKit.Text className="w-75" variant={500}>
              {helpText}
            </UiKit.Text>
            {/* <Collapse isOpen={isActive}>
              <UiKit.Flex direction="column" gap={16} className="pt-3">
                <UiKit.Separator />
                <UiKit.Flex gap={24}>
                  <UiKit.Text>Description</UiKit.Text>
                  <UiKit.Text variant={500}>{helpText}</UiKit.Text>
                </UiKit.Flex>
              </UiKit.Flex>
            </Collapse> */}
          </UiKit.Flex>
        </UiKit.Flex>
      </UiKit.Card.Body>
    </UiKit.Card>
  );
}
